<script lang="ts">
  import type { PageContent } from '$lib/def/seo/page';
		
  import { createTextEditorAction } from '$lib/serv/admin/edit';
  import { createImageEditorAction, getCimgUrl, type OnEdit } from '$lib/serv/admin/editImg';
  import { imgSrc, imgSrcSet } from '$lib/serv/image-details';
  import { editing$ } from '$lib/serv/seo';
	
	import LazyImage from '$lib/ui/shared/LazyImage.svelte';

	export let index: number;
	export let content: PageContent;
	export let editImage: OnEdit;

	const editText = createTextEditorAction('page', content.slug);
	const editImg = createImageEditorAction('page', content.slug);
</script>

<section>
	<div>
		<h4 class="label-xl" use:editText={[`block-${index}-title`]}>{content[`block-${index}-title`]}</h4>
		<p class="label-xl" use:editText={[`block-${index}-description`]}>{content[`block-${index}-description`]}</p>
	</div>
	{#if $editing$}
		<img use:editImg={[`block-${index}-img`, '1000x0', current => editImage?.(current)]} src={imgSrc(content[`block-${index}-img`], '1000x0')} alt={`block-${index}-img`}>
	{:else}
		<LazyImage {...imgSrcSet(content[`block-${index}-img`])} alt={`block-${index}-img`} />
	{/if}
</section>
<!-- <LazyImage image={yess.body_image} alt={yess.body_title}/> -->

<style lang="scss">
	@use 'color';
	@use 'screen';
	section {
		width: 100%;
		max-width: 550px;
		position: relative;
		background: color.$object-elevation-3dp;
		border-radius: 28px;
		padding: 2rem .5rem .5rem .5rem;
		font-size: 1.16rem;
		@media(min-width: 565px) { padding: 2rem .5rem .5rem .5rem; }
		@media(screen.$md) { max-width: unset; }
		// @media(screen.$mdl) { padding: 2.4rem; }
		@media(screen.$lg) { font-size: 1.3rem; }
		div {
			padding-left: 3rem;
			margin-bottom: 1rem;
			h4, p {
				text-align: left;
				display: inline;
				font-size: inherit;
				margin: 0;
			}
			h4 {
				color: color.$on-background-high-importance;
				font-weight: 700;
			}
			p {
				color: color.$on-background-medium-importance;
				font-weight: 400;
			}	
		}
		img { width: 100%; }
	}
</style>